import { render, staticRenderFns } from "./GoldCrown.vue?vue&type=template&id=a0de9412"
import script from "./GoldCrown.vue?vue&type=script&lang=js"
export * from "./GoldCrown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports